import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Unhandled error in app:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="mx-auto flex min-h-screen max-w-screen-md flex-col items-center justify-center px-6 text-center">
          <h1 className="font-serif text-3xl font-bold tracking-tight md:text-4xl">
            Something went wrong on our end.
          </h1>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-muted-foreground md:text-base">
            Please refresh the page. If this keeps happening, reach out to us and we'll sort it out.
          </p>
          <a
            href="/"
            className="mt-8 rounded-full bg-primary px-7 py-3.5 text-sm font-bold text-primary-foreground transition-transform duration-300 hover:scale-[1.03]"
          >
            Reload Eunoia
          </a>
        </div>
      );
    }

    return this.props.children;
  }
}
